// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-attachment {\n  max-height: 55vh;\n  overflow-y: scroll;\n}\n.manage-comments {\n  bottom: 60px;\n}\n.bg-card-grey {\n  min-height: 80%;\n  min-width: 85%;\n}\n[dir] .bg-card-grey {\n  background-color: #f8f8f8;\n  margin-top: 120px;\n}", ""]);
// Exports
module.exports = exports;
